// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QreGnn {
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0; /* Important for flex containers to allow shrinking */
  width: 100%; /* Take full width of parent */
  box-sizing: border-box; /* Include padding in width calculation */
}

.oiIizI {
  flex: 1;
  padding: 0;
  margin: 0;
  overflow-y: auto;
  min-height: 0; /* Allow the list to shrink and become scrollable */
  list-style-type: none;
  width: 100%; /* Take full width of parent */
  box-sizing: border-box;
}

.eLC_Mh {
  flex-shrink: 0; /* Prevent SearchBar from shrinking */
  width: 100%;
  box-sizing: border-box;
}

.zIZXx6 {
  padding: var(--spacing-2, 16px) 0 0;
  display: flex;
  flex-direction: row;
  gap: var(--spacing-2, 16px);
  flex-shrink: 0; /* Prevent footer from shrinking */
}

.EFluyY {
  flex: 1;
}

.tCjbe5 {
  padding-top: 20px;
}

.CVUF4V {
  padding: var(--spacing-1-5) var(--spacing-2);
  background: var(--surface-neutral-pale, #fafafa); /** container css **/
  margin-bottom: var(--spacing-1);
  display: grid;
  grid-template-columns: 1fr auto;
  column-gap: var(--spacing-1-5);
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  min-width: 0; /* Allow text to truncate if needed */
}

.sPuFCk {
  display: flex;
  flex-direction: column;
  min-width: 0; /* Allow text to truncate */
}

.TEYHoG {
  font-weight: var(--font-weight-semibold, 600);
  font-size: var(--type-title-md-font-size, 14px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}

.gIh4aX {
  font-weight: var(--font-weight-regular, 100);
  font-size: var(--type-title-md-font-size, 12px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}

.ZDy2ur {
  grid-column: 2;
  grid-row: 1 / span 2;
  justify-self: end;
  align-self: center;
  border: 0;
  background: transparent;
}

.TEYHoG,
.gIh4aX {
  font-family: var(--font-family-base, 'Source Sans 3');
  grid-column: 1;
  margin-bottom: 0;
}

.rRK1GY {
  padding: var(--spacing-2);
  color: var(--text-neutral-medium, #667085);
  font-family: var(--font-family-base, 'Source Sans 3');
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-layout/src/layouts/DrawerOperator/components/OperatorsList/OperatorsList.module.css"],"names":[],"mappings":"AAAA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa,EAAE,qDAAqD;EACpE,WAAW,EAAE,8BAA8B;EAC3C,sBAAsB,EAAE,yCAAyC;AACnE;;AAEA;EACE,OAAO;EACP,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,aAAa,EAAE,mDAAmD;EAClE,qBAAqB;EACrB,WAAW,EAAE,8BAA8B;EAC3C,sBAAsB;AACxB;;AAEA;EACE,cAAc,EAAE,qCAAqC;EACrD,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,cAAc,EAAE,kCAAkC;AACpD;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,4CAA4C;EAC5C,gDAAgD,EAAE,oBAAoB;EACtE,+BAA+B;EAC/B,aAAa;EACb,+BAA+B;EAC/B,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,YAAY,EAAE,qCAAqC;AACrD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY,EAAE,2BAA2B;AAC3C;;AAEA;EACE,6CAA6C;EAC7C,+CAA+C;EAC/C,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,4CAA4C;EAC5C,+CAA+C;EAC/C,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,uBAAuB;AACzB;;AAEA;;EAEE,qDAAqD;EACrD,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,0CAA0C;EAC1C,qDAAqD;AACvD","sourcesContent":[".container {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  min-height: 0; /* Important for flex containers to allow shrinking */\n  width: 100%; /* Take full width of parent */\n  box-sizing: border-box; /* Include padding in width calculation */\n}\n\n.listContainer {\n  flex: 1;\n  padding: 0;\n  margin: 0;\n  overflow-y: auto;\n  min-height: 0; /* Allow the list to shrink and become scrollable */\n  list-style-type: none;\n  width: 100%; /* Take full width of parent */\n  box-sizing: border-box;\n}\n\n.searchBar {\n  flex-shrink: 0; /* Prevent SearchBar from shrinking */\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.footer {\n  padding: var(--spacing-2, 16px) 0 0;\n  display: flex;\n  flex-direction: row;\n  gap: var(--spacing-2, 16px);\n  flex-shrink: 0; /* Prevent footer from shrinking */\n}\n\n.footerButton {\n  flex: 1;\n}\n\n.loadingContainer {\n  padding-top: 20px;\n}\n\n.operatorItem {\n  padding: var(--spacing-1-5) var(--spacing-2);\n  background: var(--surface-neutral-pale, #fafafa); /** container css **/\n  margin-bottom: var(--spacing-1);\n  display: grid;\n  grid-template-columns: 1fr auto;\n  column-gap: var(--spacing-1-5);\n  align-items: center;\n  width: 100%;\n  box-sizing: border-box;\n  min-width: 0; /* Allow text to truncate if needed */\n}\n\n.operatorInfo {\n  display: flex;\n  flex-direction: column;\n  min-width: 0; /* Allow text to truncate */\n}\n\n.operatorName {\n  font-weight: var(--font-weight-semibold, 600);\n  font-size: var(--type-title-md-font-size, 14px);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  min-width: 0;\n}\n\n.operatorRoles {\n  font-weight: var(--font-weight-regular, 100);\n  font-size: var(--type-title-md-font-size, 12px);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  min-width: 0;\n}\n\n.deleteOperatorIcon {\n  grid-column: 2;\n  grid-row: 1 / span 2;\n  justify-self: end;\n  align-self: center;\n  border: 0;\n  background: transparent;\n}\n\n.operatorName,\n.operatorRoles {\n  font-family: var(--font-family-base, 'Source Sans 3');\n  grid-column: 1;\n  margin-bottom: 0;\n}\n\n.emptyState {\n  padding: var(--spacing-2);\n  color: var(--text-neutral-medium, #667085);\n  font-family: var(--font-family-base, 'Source Sans 3');\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `QreGnn`,
	"listContainer": `oiIizI`,
	"searchBar": `eLC_Mh`,
	"footer": `zIZXx6`,
	"footerButton": `EFluyY`,
	"loadingContainer": `tCjbe5`,
	"operatorItem": `CVUF4V`,
	"operatorInfo": `sPuFCk`,
	"operatorName": `TEYHoG`,
	"operatorRoles": `gIh4aX`,
	"deleteOperatorIcon": `ZDy2ur`,
	"emptyState": `rRK1GY`
};
module.exports = ___CSS_LOADER_EXPORT___;
